export enum Logic {
    Completable = 0,
    Beatable = 1,
    Chaos = 2,
}
